
import { Button } from "@/components/ui/button";
import { Trash2 } from "lucide-react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

interface CategoriasOutrosListProps {
  categorias: { categoria: string; itens: string[] }[];
  onDeleteItem: (categoria: string, item: string) => void;
}

export const CategoriasOutrosList = ({ 
  categorias, 
  onDeleteItem 
}: CategoriasOutrosListProps) => {
  return (
    <div>
      <h3 className="font-semibold mb-4">Itens Cadastrados</h3>
      <div className="border rounded-md">
        <Accordion type="multiple" className="w-full">
          {categorias.length === 0 ? (
            <div className="p-4 text-center text-muted-foreground">
              Nenhuma categoria cadastrada.
            </div>
          ) : (
            categorias.map((cat, i) => (
              <AccordionItem value={`item-${i}`} key={i}>
                <AccordionTrigger className="px-4">
                  {cat.categoria}
                </AccordionTrigger>
                <AccordionContent className="px-4">
                  <div className="space-y-2">
                    {cat.itens.map((item, j) => (
                      <div key={j} className="flex justify-between items-center p-2 border-b">
                        <span>{item}</span>
                        <AlertDialog>
                          <AlertDialogTrigger asChild>
                            <Button
                              variant="ghost"
                              size="icon"
                              className="text-destructive hover:text-destructive"
                            >
                              <Trash2 className="h-4 w-4" />
                            </Button>
                          </AlertDialogTrigger>
                          <AlertDialogContent>
                            <AlertDialogHeader>
                              <AlertDialogTitle>Confirmar exclusão</AlertDialogTitle>
                              <AlertDialogDescription>
                                Tem certeza que deseja excluir o item {item} da categoria {cat.categoria}?
                              </AlertDialogDescription>
                            </AlertDialogHeader>
                            <AlertDialogFooter>
                              <AlertDialogCancel>Cancelar</AlertDialogCancel>
                              <AlertDialogAction 
                                onClick={() => onDeleteItem(cat.categoria, item)}
                              >
                                Excluir
                              </AlertDialogAction>
                            </AlertDialogFooter>
                          </AlertDialogContent>
                        </AlertDialog>
                      </div>
                    ))}
                  </div>
                </AccordionContent>
              </AccordionItem>
            ))
          )}
        </Accordion>
      </div>
    </div>
  );
};
